import '@fontsource/roboto'
import '@fontsource/noto-sans'
import React from 'react'
import {createRoot} from 'react-dom/client'
import {initAwsConfiguration, initSentryConfiguration} from './config/oc-shell.config'
import {configureMonaco} from './configureMonaco'
import App from './App'

const url = await initAwsConfiguration()
initSentryConfiguration(url)

configureMonaco()

const app =
    import.meta.env.VITE_STAGE === 'local' ? (
        <React.StrictMode>
            <App />
        </React.StrictMode>
    ) : (
        <App />
    )

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)
root.render(app)
